
import React from 'react';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { Growl } from 'primereact/growl';
import { Archivo } from './Archivo';
import { Dialog } from "primereact/dialog";
import { TablaResultados } from './TablaResultados';
import { obtenerBytesBase64Archivos } from '../servicio/ServicioLecturaArchivos';
import servicioObjetos from '../servicio/ServicioObjetos';
import servicioHttp from '../servicio/ServicioHttp';
import servicioArchivos from '../servicio/ServicioArchivos';

const RESULTADOS_PERSONALES_EBA = {
    columnas: [{ field: "nssSua", header: "NSS SUA", compareTo: 'nssNomina', typeValue: 'String' },
    { field: "nombreSua", header: "Nombre SUA", compareTo: 'nombreNomina', typeValue: 'String' },
    { field: "rfcSua", header: "RFC SUA", compareTo: 'rfcNomina', typeValue: 'String' },
    { field: "curpSua", header: "CURP SUA", compareTo: 'curpNomina', typeValue: 'String' },
    { field: "nssNomina", header: "NSS NOMINA", compareTo: 'nssSua', typeValue: 'String' },
    { field: "nombreNomina", header: "Nombre NOMINA", compareTo: 'nombreSua', typeValue: 'String' },
    { field: "rfcNomina", header: "RFC NOMINA", compareTo: 'rfcSua', typeValue: 'String' },
    { field: "curpNomina", header: "CURP NOMINA", compareTo: 'curpSua', typeValue: 'String' }],
    datos: []
};
const RESULTADOS_CAMBIOSALARIO_EBA = {
    columnas: [
        { field: "nss", header: "NSS", typeValue: 'String' },
        { field: "nombre", header: "Nombre", typeValue: 'String' },
        { field: "fechaSua", header: "Fecha Mov. SUA", compareTo: 'fechaNomina', typeValue: 'Date' },
        { field: "salarioSua", header: "Salario SUA", compareTo: 'salarioNomina', typeValue: 'Number' },
        { field: "fechaNomina", header: "Fecha Mov. NOMINA", compareTo: 'fechaSua', typeValue: 'Date' },
        { field: "salarioNomina", header: "Salario NOMINA", compareTo: 'salarioSua', typeValue: 'Number' }],
    datos: []
};

const RESULTADOS_INCAPACIDADES_EBA = {
    columnas: [
        { field: "nss", header: "NSS", typeValue: 'String' },
        { field: "nombre", header: "Nombre", typeValue: 'String' },
        { field: "fecha", header: "Fecha", typeValue: 'Date' },
        { field: "folio", header: "Folio", typeValue: 'String' },
        { field: "dias", header: "Días", typeValue: 'Number' },
        { field: "diasMes", header: "Días Mes", typeValue: 'Number' },
        { field: "diasBimestre", header: "Días Bimestre", typeValue: 'Number' }],
    datos: []
};

const RESULTADOS_AUSENTISMOS_EBA = {
    columnas: [
        { field: "nss", header: "NSS", typeValue: 'String' },
        { field: "nombre", header: "Nombre", typeValue: 'String' },
        { field: "fecha", header: "Fecha", typeValue: 'Date' },
        { field: "dias", header: "Días", typeValue: 'Number' },
        { field: "diasMes", header: "Días Mes", typeValue: 'Number' },
        { field: "diasBimestre", header: "Días Bimestre", typeValue: 'Number' }],
    datos: []
};

const RESULTADOS_DIFERENCIASCREDITOS_EBA = {
    columnas: [
        { field: "nss", header: "NSS", typeValue: 'String' },
        { field: "nombre", header: "Nombre", typeValue: 'String' },
        { field: "creditoNnomina", header: "Crédito NOMINA", typeValue: 'String', compareTo: 'creditoSua' },
        { field: "creditoSua", header: "Crédito SUA", typeValue: 'String', compareTo: 'creditoNnomina' }],
    datos: []
};
const RESULTADOS_EMPLEADOSINFONAVIT_EBA = {
    columnas: [
        { field: 'nss', header: 'NSS', typeValue: 'String' },
        { field: 'nombre', header: 'Nombre', typeValue: 'String' },
        { field: 'noCreditoSua', header: '# Crédito SUA', typeValue: 'String', compareTo: 'noCreditoNomina' },
        { field: 'noCreditoNomina', header: '# Crédito NOMINA', typeValue: 'String', compareTo: 'noCreditoSua' },
        { field: 'amortizacionSua', header: 'Amortización SUA', typeValue: 'Number', compareTo: 'amortizacionNomina' },
        { field: 'amortizacionNomina', header: 'Amortización NOMINA', typeValue: 'Number', compareTo: 'amortizacionSua' },
        { header: 'Diferencia en amortización', difference: { first: 'amortizacionSua', second: 'amortizacionNomina' } },
        { field: 'tipoDescuentoSua', header: 'Tipo descuento SUA', typeValue: 'String', compareTo: 'tipoDescuentoNomina' },
        { field: 'tipoDescuentoNomina', header: 'Tipo descuento NOMINA', typeValue: 'String', compareTo: 'tipoDescuentoSua' },
        { field: 'valorDescuetoSua', header: 'Valor de descuento SUA', typeValue: 'Number', compareTo: 'valorDescuentoNomina' },
        { field: 'valorDescuentoNomina', header: 'Valor de descuento NOMINA', typeValue: 'Number', compareTo: 'valorDescuetoSua' },
        { field: 'diasSua', header: 'Días Bim Sua', typeValue: 'Number', compareTo: 'diasNomina' },
        { field: 'diasNomina', header: 'Días Bim NOMINA', typeValue: 'Number', compareTo: 'diasSua' },
        { field: 'incSua', header: 'Inc. Bim SUA', typeValue: 'Number', compareTo: 'incNomina' },
        { field: 'incNomina', header: 'Inc. Bim NOMINA', typeValue: 'Number', compareTo: 'incSua' },
        { field: 'ausSua', header: 'Aus. Bim SUA', typeValue: 'Number', compareTo: 'ausNomina' },
        { field: 'ausNomina', header: 'Aus. Bim NOMINA', typeValue: 'Number', compareTo: 'ausSua' }
    ],
    datos: []
};
const RESULTADOS_MOVIMIENTOSINFONAVIT_EBA = {
    columnas: [
        { field: 'nss', header: 'NSS', typeValue: 'String' },
        { field: 'nombre', header: 'Nombre', typeValue: 'String' },
        { field: 'numCredito', header: 'Núm. Crédito', typeValue: 'String' },
        { field: 'fecha', header: 'Fecha', typeValue: 'Date' },
        { field: 'valorDeDescuento', header: 'Valor de descuento', typeValue: 'Number' },
        { field: 'tipoCredito', header: 'Tipo crédito', typeValue: 'String' },
        { field: 'movimiento', header: 'Movimiento', typeValue: 'String' },
    ],
    datos: []
};
export class ConfrontaSuaNomina extends React.Component {

    constructor() {
        super();
        this.state = {
            tipos:
                [{ label: "Seleccione una opción", value: null },
                { label: "Confronta Mensual", value: 1 },
                { label: "Confronta Bimestal", value: 2 }],
            confrontas: null,
            confronta: {},
            respuestaConfronta: {},
            wrapperDatosPersonales: {
                ...RESULTADOS_PERSONALES_EBA
            },
            wrapperCambioSalario: {
                ...RESULTADOS_CAMBIOSALARIO_EBA
            },
            wrapperAltaReingreso: {
                ...RESULTADOS_CAMBIOSALARIO_EBA
            },
            wrapperBaja: {
                ...RESULTADOS_CAMBIOSALARIO_EBA
            },
            wrapperIncapacidades: {
                ...RESULTADOS_INCAPACIDADES_EBA
            },
            wrapperAusentismos: {
                ...RESULTADOS_AUSENTISMOS_EBA
            },
            wrapperDiferenciasCreditos: {
                ...RESULTADOS_DIFERENCIASCREDITOS_EBA
            },
            wrapperEmpleadosInfonavit: {
                ...RESULTADOS_EMPLEADOSINFONAVIT_EBA
            },
            wrapperMovimientosInfonavit: {
                ...RESULTADOS_MOVIMIENTOSINFONAVIT_EBA
            },
            contenidoModal: null,
            verModalResultados: false,
            errorPlantilla:{},
            mostrarModalErrorPlantilla:false
        };
    }

    asignarValores = (event) => {
        servicioObjetos.asignarAtributosObjeto(event, this, false);
    };

    cargarArchivo = (event) => {
        obtenerBytesBase64Archivos(event, this);
    }

    generarConfronta = () => {
        let { confronta, confrontas, wrapperDatosPersonales,
            wrapperCambioSalario, wrapperAltaReingreso, wrapperBaja,
            wrapperIncapacidades, wrapperAusentismos, wrapperDiferenciasCreditos,
            wrapperEmpleadosInfonavit, wrapperMovimientosInfonavit } = this.state;
        let validacion = this.validarFormulario(confronta, confrontas);
        if (servicioObjetos.esObjetoVacio(validacion)) {
            let url = '/confronta/nominasua/mensual/procesar.json';
            if (confrontas === 2)
                url = '/confronta/nominasua/bimestral/procesar.json';
            let {sua} =confronta;
            confronta.sua=[];
            confronta.sua.push(sua);
            let {credito} =confronta;
            confronta.credito=[];
            confronta.credito.push(credito);
            servicioHttp.consumirPostHttp(url, confronta).then(response => {
                let data=response.data;
                if (data.error) {
                    if (data.mensaje === "validacionXlsx") {                        
                        let errorPlantilla = { cuerpo: data.objeto };
                        this.setState({ errorPlantilla, mostrarModalErrorPlantilla: true });
                    } else {
                        this.growl.show({ severity: 'error', summary: 'Mensaje', detail: "Existe un error al procesar sus archivos de confronta, si el error persiste contacte a soporte al cliente" });
                    }                    
                } else {
                    let respuesta = data.objeto;                
                    this.setState({ respuestaConfronta: respuesta });
                    wrapperDatosPersonales.datos = respuesta.datosPersonalesSuaNomina;
                    wrapperCambioSalario.datos = respuesta.cambioSalarioNominaSua;
                    wrapperAltaReingreso.datos = respuesta.reingresoAltaNominaSua;
                    wrapperBaja.datos = respuesta.bajaNominaSua;
                    wrapperIncapacidades.datos = respuesta.incapacidadesNominaSua;
                    wrapperAusentismos.datos = respuesta.ausentismosNominaSua;
                    wrapperDiferenciasCreditos.datos = respuesta.diferenciaCreditosNominaSua;
                    wrapperEmpleadosInfonavit.datos = respuesta.empleadosInfonavitNominaSua;
                    wrapperMovimientosInfonavit.datos = respuesta.movimientosInfonavitNominaSua;
                    this.setState({
                        wrapperDatosPersonales, wrapperCambioSalario, wrapperAltaReingreso,
                        wrapperBaja, wrapperIncapacidades, wrapperAusentismos, wrapperDiferenciasCreditos,
                        wrapperEmpleadosInfonavit
                    });
    
                    this.growl.show({ severity: 'success', summary: 'Mensaje', detail: "Confronta generada con éxito" });
                }                
            }).catch(error => {
                this.setState({ respuestaConfronta: {} });
            });
        } else {
            this.growl.show({ severity: 'error', summary: 'Mensaje', detail: validacion });
        }
    }

    descargaConfrontaNominaSuaEma = () => {
        let { respuestaConfronta } = this.state;
        let arregloBytes = servicioArchivos.base64ToArrayBuffer(respuestaConfronta.archivoConfrontaGeneral);
        let nombre_archivo = "ConfrontaNominaSua.xlsx";
        servicioArchivos.guardarByteArray(nombre_archivo, arregloBytes);
    }

    descargaResultadosConfrontaNominaSuaEma = () => {
        let { respuestaConfronta } = this.state;
        let arregloBytes = servicioArchivos.base64ToArrayBuffer(respuestaConfronta.archivoResultadosConfrontaGeneral);
        let nombre_archivo = "ResultadosConfrontaNominaSua.xlsx";
        servicioArchivos.guardarByteArray(nombre_archivo, arregloBytes);
    }

    descargarErrorPlantilla = () => {
        let {errorPlantilla} =this.state;
        let arregloBytes = servicioArchivos.base64ToArrayBuffer(errorPlantilla.cuerpo);
        let nombre_archivo = "erroresPlantilla.xlsx";
        servicioArchivos.guardarByteArray(nombre_archivo, arregloBytes);
    }

    validarFormulario = (confronta, confrontas) => {        
        if (servicioObjetos.esObjetoVacio(confronta))
            return "Debe de elegir archivos necesarios para realizar la confronta";
        if (servicioObjetos.esObjetoVacio(confronta.sua))
            return "Debe de elegir el archivo SUA para la confrontra";
        if (servicioObjetos.esObjetoVacio(confronta.plantillaExcel))
            return "Debe de elegir un archivo plantilla universal .xlsx para la confronta";
        if (confrontas === 2 && (null === confronta.credito || undefined===confronta.credito ))
            return "Debe de elegir un archivo de créditos para la confronta";
    }

    descargarArchivoXlsxNomina = () => {
        servicioArchivos.descargaArchivo('/confronta/nominasua/plantilla.json');
    }

    cambioSelectConfrontas = (event) => {
        this.setState({ confrontas: null });
        setTimeout(() => this.reidsenubeValores(event), 100);
    }

    reidsenubeValores = (event) => {
        if (!servicioObjetos.esObjetoVacio(event))
            this.setState({ confrontas: event.value });
        this.setState({ confronta: {}, respuestaConfronta: {}, contenidoModal: null, errorPlantilla: {} });
    }

    mostrarResultados = (valor) => {
        let { wrapperDatosPersonales, wrapperCambioSalario,
            wrapperAltaReingreso, wrapperBaja,
            wrapperIncapacidades, wrapperAusentismos, wrapperDiferenciasCreditos,
            wrapperEmpleadosInfonavit, wrapperMovimientosInfonavit } = this.state;
        let contenidoModal = null;
        let tituloModal = "";
        switch (valor) {
            case 'Datos Personales':
                contenidoModal = <TablaResultados wrapper={wrapperDatosPersonales} />;
                tituloModal = "Datos Personales";
                break;
            case 'Cambio Salario':
                contenidoModal = <TablaResultados wrapper={wrapperCambioSalario} />;
                tituloModal = "Cambio Salario";
                break;
            case 'Reingreso - Alta':
                tituloModal = "Reingreso - Alta";
                contenidoModal = <TablaResultados wrapper={wrapperAltaReingreso} />;
                break;
            case 'Baja':
                tituloModal = "Baja";
                contenidoModal = <TablaResultados wrapper={wrapperBaja} />;
                break;
            case 'Incapacidades':
                contenidoModal = <TablaResultados wrapper={wrapperIncapacidades} />;
                tituloModal = "Incapacidades";
                break;
            case 'Ausentismos':
                contenidoModal = <TablaResultados wrapper={wrapperAusentismos} />;
                tituloModal = "Ausentismos";
                break;
            case 'Diferencias Créditos':
                contenidoModal = <TablaResultados wrapper={wrapperDiferenciasCreditos} />;
                tituloModal = "Diferencias Créditos";
                break;
            case 'Empleados Infonavit':
                contenidoModal = <TablaResultados wrapper={wrapperEmpleadosInfonavit} />;
                tituloModal = "Empleados Infonavit";
                break;
            case 'Movimientos Infonavit':
                tituloModal = "Movimientos Infonavit";
                contenidoModal = <TablaResultados wrapper={wrapperMovimientosInfonavit} />;
                break;
            default:
                break;
        }
        this.setState({ contenidoModal: contenidoModal, verModalResultados: true, tituloModal });
    }

    cerrarModalResultados = () => {
        this.setState({ contenidoModal: null, verModalResultados: false,mostrarModalErrorPlantilla:false });
    }

    render() {
        let { confrontas, tipos, respuestaConfronta, contenidoModal, verModalResultados,
            tituloModal, mostrarModalErrorPlantilla } = this.state;
        return (
            <div>
                <div className="card card-w-title">
                    <Growl ref={(el) => (this.growl = el)} />
                    <div className="p-grid">
                        <div className="p-col-12 p-md-12">
                            <center><h1>Confronta Nomina - SUA</h1></center>
                        </div>
                        <div className="p-col-12 p-md-4 p-md-offset-8">
                            <Button label="Descargar archivo .xlsx nomina" icon="pi-md-file-download" onClick={this.descargarArchivoXlsxNomina} />
                        </div>
                    </div>

                    <div className="p-grid">
                        <div className="p-col-12 p-md-2">
                            <label><strong>* Tipo de Confronta:</strong></label>
                        </div>
                        <div className="p-col-12 p-md-5 p-md-offset-2">
                            <Dropdown options={tipos} value={confrontas} onChange={(event) => this.cambioSelectConfrontas(event)} />
                        </div>
                        <div className="p-col-12 p-md-12"></div>
                    </div>
                    {confrontas === 1 || confrontas === 2 ? <div className="p-grid">
                        <div className="p-col-12 p-md-2">
                            <label><strong>* Selecciona el archivo pago SUA (.sua):</strong></label>
                        </div>
                        <div className="p-col-12 p-md-8 p-md-offset-2">
                            <Archivo id="confronta.sua" nombre="confronta.sua" etiqueta="Seleccionar archivo.sua" cambio={this.cargarArchivo} aceptar=".sua" />
                        </div>
                        <div className="p-col-12 p-md-12"></div>
                        <div className="p-col-12 p-md-2">
                            <label><strong>* Selecciona el archivo plantilla nómina universal (.xlsx):</strong></label>
                        </div>
                        <div className="p-col-12 p-md-8 p-md-offset-2">
                            <Archivo id="confronta.plantillaExcel" nombre="confronta.plantillaExcel" etiqueta="Seleccionar archivo.xlsx" cambio={this.cargarArchivo} aceptar=".xlsx" />
                        </div>
                        <div className="p-col-12 p-md-12"></div>
                    </div> : null}
                    {confrontas === 2 ? <div className="p-grid">
                        <div className="p-col-12 p-md-2">
                            <label><strong>* Selecciona el archivo de créditos (.txt):</strong></label>
                        </div>
                        <div className="p-col-12 p-md-8 p-md-offset-2">
                            <Archivo id="confronta.credito" nombre="confronta.credito" etiqueta="Seleccionar archivo.txt" cambio={this.cargarArchivo} aceptar=".txt" />
                        </div>
                        <div className="p-col-12 p-md-12"></div>
                    </div> : null}
                    {confrontas === 1 || confrontas === 2 ? <div className="p-grid">
                        <div className="p-col-12 p-md-2">
                            <Button label="Confrontar" icon="pi-md-folder" onClick={this.generarConfronta} />
                        </div>
                        <div className="p-col-12 p-md-2">
                            <Button label="Limpiar" icon="pi-md-refresh" onClick={() => this.cambioSelectConfrontas({ value: confrontas })} />
                        </div>
                    </div> : null}
                    <div className="p-grid">
                        {!servicioObjetos.esObjetoVacio(respuestaConfronta) ? <div className="p-col-12 p-md-4">
                            <Button label={"Descarga Confronta Nomina Sua " + (confrontas === 1 ? "Mensual" : "Bimestral")} icon="pi-md-file-download" onClick={this.descargaConfrontaNominaSuaEma} />
                        </div> : null}
                        {!servicioObjetos.esObjetoVacio(respuestaConfronta) ? <div className="p-col-12 p-md-4">
                            <Button label={"Descarga Resultados Nomina Sua " + (confrontas === 1 ? "Mensual" : "Bimestral")} icon="pi-md-file-download" onClick={this.descargaResultadosConfrontaNominaSuaEma} />
                        </div> : null}
                    </div>
                </div>
                {!servicioObjetos.esObjetoVacio(respuestaConfronta) ? <div className="card">
                    <div className="p-grid">
                        <div className="p-col-12 p-md-2">
                            <Button label="Datos Personales" icon="pi-md-folder" onClick={() => this.mostrarResultados("Datos Personales")} />
                        </div>
                        <div className="p-col-12 p-md-2">
                            <Button label="Cambio Salario" icon="pi-md-folder" onClick={() => this.mostrarResultados("Cambio Salario")} />
                        </div>
                        <div className="p-col-12 p-md-2">
                            <Button label="Reingreso - Alta" icon="pi-md-folder" onClick={() => this.mostrarResultados("Reingreso - Alta")} />
                        </div>
                        <div className="p-col-12 p-md-2">
                            <Button label="Baja" icon="pi-md-folder" onClick={() => this.mostrarResultados("Baja")} />
                        </div>
                        <div className="p-col-12 p-md-2">
                            <Button label="Incapacidades" icon="pi-md-folder" onClick={() => this.mostrarResultados("Incapacidades")} />
                        </div>
                        <div className="p-col-12 p-md-2">
                            <Button label="Ausentismos" icon="pi-md-folder" onClick={() => this.mostrarResultados("Ausentismos")} />
                        </div>
                        {confrontas === 2 ? <div>
                            <div className="p-col-12 p-md-2">
                                <Button label="Diferencias Créditos" icon="pi-md-folder" onClick={() => this.mostrarResultados("Diferencias Créditos")} />
                            </div>
                            <div className="p-col-12 p-md-2">
                                <Button label="Empleados Infonavit" icon="pi-md-folder" onClick={() => this.mostrarResultados("Empleados Infonavit")} />
                            </div>
                            <div className="p-col-12 p-md-2">
                                <Button label="Movimientos Infonavit" icon="pi-md-folder" onClick={() => this.mostrarResultados("Movimientos Infonavit")} />
                            </div>
                        </div> : null}

                    </div>
                </div> : null}
                <Dialog header={tituloModal} appendTo={document.body} style={{ width: '90%', height: '70%' }} visible={verModalResultados} onHide={this.cerrarModalResultados} modal={true} >
                    {contenidoModal}
                </Dialog>
                <Dialog header={"Error en plantilla Nómina"} appendTo={document.body} style={{ width: '50%', height: '40%' }} visible={mostrarModalErrorPlantilla} onHide={this.cerrarModalResultados} modal={true} >
                    <div className="card">
                        <div className="p-grid">
                        <div className="p-col-12 p-md-12">Parece que su plantilla .XLSX tiene datos inválidos, revise el archivo .XLSX debe de haber celdas en color rojo</div>                        
                            <div className="p-col-12 p-md-4"></div>
                            <div className="p-col-12 p-md-4"><Button label={"Descarga error plantilla " + (confrontas === 1 ? "Mensual" : "Bimestral")} icon="pi-md-file-download" onClick={this.descargarErrorPlantilla} /></div>
                            <div className="p-col-12 p-md-4"></div>
                        </div>
                    </div>
                </Dialog>
            </div>
        );
    }
}